//import './smoothScroll';

const getMax = () => $(document).height() - $(window).height();

const getValue = () => $(window).scrollTop();

const affix = () => {
  const scrolled = $(window).scrollTop();

  if (scrolled > $('nav.navbar').height())
    $('nav.navbar').addClass('affix');
  else
    $('nav.navbar').removeClass('affix');
}

const fullWidth = window.innerWidth;

const fullHeight = () => {
  const vh = window.innerHeight;

  $(':root').css('--vh', `${vh}px`);
}

fullHeight();

const progressBar = $('progress');

progressBar.attr({
  max: getMax()
});

// toggle hamburger and cross icon
$('button.navbar-toggler').on('click', event => $(event.currentTarget).children().toggleClass('fa-bars').toggleClass('fa-times'));

// add chevron-up when open
$('.collapse').on('shown.bs.collapse', function () {
  $(this).prev('.list-group-item').children('svg.svg-inline--fa').removeClass('fa-chevron-down').addClass('fa-chevron-up')
})

// remove chevron-up when closed
$('.collapse').on('hidden.bs.collapse', function () {
  $(this).prev('.list-group-item').children('svg.svg-inline--fa').addClass('fa-chevron-down').removeClass('fa-chevron-up')
})

$(document).on('scroll', () => {
  window.requestAnimationFrame(function () {

    progressBar.attr({
      value: getValue()
    });

    affix();
  });
});

$(window).resize(() => {
  window.requestAnimationFrame(function () {

    progressBar.attr({
      max: getMax(),
      value: getValue()
    });

    if (fullWidth != window.innerWidth) {
      fullHeight();
    }
  });
});